import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { isEmpty } from 'lodash-es';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { getFullName } from '@frontend/name';
import { useModalControl } from '@frontend/design-system';
import { useCheckPaymentsEnabled } from '../../../../../../../hooks/use-check-payments-enabled';
import { ScheduleRequestListItem } from '../../../../../../../types';
import { useScheduleRequestNotificationsAsRead } from '../../hooks/use-schedule-request-notifications-as-read';
import { PreferenceBasedScheduleRequestItemHeader } from './preference-based-item-header';
import { ScheduleRequestListItemHeader } from './schedule-request-item-header';

export type ScheduleRequestItemHeaderProps = {
  isWidgetListItem?: boolean;
  listItem: ScheduleRequestListItem;
  setSelectedScheduleRequest: React.Dispatch<React.SetStateAction<ScheduleRequest | null>>;
  scheduleRequestModalProps: ReturnType<typeof useModalControl>;
  locationChip?: (locationName: string) => React.ReactNode;
};

export const ScheduleRequestItemHeader = ({
  isWidgetListItem,
  listItem,
  setSelectedScheduleRequest,
  scheduleRequestModalProps,
  locationChip,
}: ScheduleRequestItemHeaderProps) => {
  const { isPaymentsEnabled } = useCheckPaymentsEnabled(listItem.locationId);
  const { markNotificationsAsRead } = useScheduleRequestNotificationsAsRead();

  const { isPreferenceBasedRequestEnabled } = SchedulerV3.Helpers.useGetPreferenceBasedRequestFeatureFlagDetails();
  const isPreferenceBasedRequest = !isEmpty(listItem.bookingDetails);

  const sharedProps = {
    requestVersion: listItem.linkHash || '',
    name: getFullName(listItem.schedulee ?? {}),
    personId: listItem.schedulee?.weavePersonId,
    appointmentTime: listItem?.dateTime ?? '',
    personPhone: listItem?.schedulee?.phoneNumber ?? '',
    locationId: listItem.locationId ?? '',
    scheduleRequestId: listItem.id ?? '',
    isWidgetListItem,
    markNotificationsAsRead,
    locationChip,
  };

  const updateSelectedScheduleRequest = () => {
    if (isPreferenceBasedRequestEnabled && isPreferenceBasedRequest) {
      // TODO: Handle widget action
    } else {
      setSelectedScheduleRequest(listItem);
      scheduleRequestModalProps.openModal();
    }
  };

  return isPreferenceBasedRequestEnabled && isPreferenceBasedRequest ? (
    <PreferenceBasedScheduleRequestItemHeader
      {...sharedProps}
      updateSelectedScheduleRequest={updateSelectedScheduleRequest}
      bookingDetails={listItem.bookingDetails}
    />
  ) : (
    <ScheduleRequestListItemHeader
      {...sharedProps}
      paidAmount={isPaymentsEnabled && listItem?.bookingAmount ? listItem?.bookingAmount : 0}
      updateSelectedScheduleRequest={updateSelectedScheduleRequest}
    />
  );
};
